import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const lines = (h) => (h || '').replace(/<\/(p|li|h\d)>/g, '\n').replace(/<[^>]+>/g, '').split('\n').map((x) => x.trim()).filter(Boolean);

export const LetterRevisions = ({ revisions }) => {
  const [sel, setSel] = useState(null);
  const sorted = [...(revisions || [])].sort((a, b) => b.rev - a.rev);
  const cur = sorted.find((r) => r.rev === sel);
  const prev = cur && sorted.find((r) => r.rev === cur.rev - 1);
  const a = new Set(lines(prev?.html));
  const b = new Set(lines(cur?.html));
  return (
    <Card data-testid="letter-revisions"><CardHeader className="pb-2"><CardTitle className="text-base">Revision history</CardTitle></CardHeader><CardContent className="space-y-2 text-sm">
      <div className="flex flex-wrap gap-2">{sorted.map((r) => (
        <button key={r.rev} type="button" onClick={() => setSel(r.rev)} data-testid={`letter-rev-${r.rev}`}
          className={`rounded border px-2 py-1 text-xs transition-colors ${sel === r.rev ? 'border-primary bg-primary/5' : 'hover:bg-muted'}`}>Rev {r.rev} · {new Date(r.at).toLocaleString('en-AU')} · {r.note}</button>))}</div>
      {cur && <div className="space-y-1 rounded border p-2 text-xs" data-testid="letter-rev-diff">
        {[...a].filter((x) => !b.has(x)).map((x) => <p key={`-${x}`} className="bg-red-50 text-red-800 line-through">− {x}</p>)}
        {[...b].filter((x) => !a.has(x)).map((x) => <p key={`+${x}`} className="bg-emerald-50 text-emerald-800">+ {x}</p>)}
        {prev && [...b].every((x) => a.has(x)) && [...a].every((x) => b.has(x)) && <p className="text-muted-foreground">No wording changes (answers only).</p>}
        {!prev && <p className="text-muted-foreground">First revision (generated from the template).</p>}
      </div>}
    </CardContent></Card>
  );
};
